import { useEffect } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { path } from 'ramda'
import { useHistory } from 'react-router'
import { select } from '@/store'
import { DefaultButtonBar } from '@/components/button-bar'
import { Button } from '@/components/button'
import { showStopPadPaymentsModal } from '@/features/Pad/modals'
import PaymentStatus from './payment-status'
import TransactionSummary from './transaction-summary'
import AccountInfo from './account-info'

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
`

const getFinancialInfo = path(['payment_method', 'financial_info'])

const LandlordPadPaymentDetails = ({ paymentData, listingId }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()

  const contractId = useSelector(path(['listing', listingId, 'contract', 'listing_contract_id']))
  const listingAddress = useSelector(path(['listing', listingId, 'contract', 'address']))

  const contract = useSelector(state => select.contract.contractView(state, { contractId }))
  const padActive = contract.pad_active
  const handleSubmit = () => history.replace(`/tenant/${listingId}/payments`)

  useEffect(() => {
    if (contractId) {
      dispatch.contract.load(contractId)
    }
  }, [contractId, dispatch.contract])

  const handleStopPad = () =>
    showStopPadPaymentsModal({
      listingAddress,
      contractId,
      submitAction: handleSubmit
    })
  const financialInfo = getFinancialInfo(paymentData)

  return (
    <>
      <InnerWrapper>
        <PaymentStatus paymentData={paymentData} padActive={padActive} />
        <TransactionSummary paymentData={paymentData} listingId={listingId} />
        <AccountInfo financialData={financialInfo} />
      </InnerWrapper>
      <DefaultButtonBar paymentData={paymentData}>
        {paymentData?.payment_status === 'upcoming' && padActive && (
          <Button theme="delete" size="small" onClick={handleStopPad} disabled={!contractId}>
            {t('b.payment.view.stop_pad.button', 'Stop PAD')}
          </Button>
        )}
      </DefaultButtonBar>
    </>
  )
}

export default LandlordPadPaymentDetails
